const PersonalCenterWalletCard = {
    baseStyle: {},
  defaultProps: {},
  internalDefaultProps: {}
}

export default PersonalCenterWalletCard;